import React from "react"
import CategoryModal from "../../Common/FilterModal/Category"
import LocationModal from "../../Common/FilterModal/Location"
import FilterRow from "../../Common/Filter/Row"
import Loader from "../../Common/Loader"

import * as styles from "./Styles/PC.module.scss"
import "../../../styles/layouts"
import classNames from "classnames/bind"
const cn = classNames.bind(styles)

const PC = (props) => {
  return (
    <React.Fragment>
      <div className={styles.container}>
        <FilterRow
          target={props.city || props.prefecture}
          fallback="エリアを選ぶ"
          iconParam={{ type: "feather", name: "map" }}
          onClick={props.handleLocationClick}
        />
        <FilterRow
          target={props.category}
          fallback="カテゴリを選ぶ"
          iconParam={{ type: "original", name: "building" }}
          onClick={props.handleCategoryClick}
        />
      </div>
      <LocationModal
        {...props}
        show={props.showLocationModal}
        onHide={() => props.setShowLocationModal(false)}
        onChange={(city, pref) => {
          props.setShowLocationModal(false)
          props.handleLocationSelected(city, pref, props.category)
        }}
      />
      <CategoryModal
        {...props}
        show={props.showCategoryModal}
        onHide={() => props.setShowCategoryModal(false)}
        onChange={(category) => {
          props.handleCategorySelected(category, props.city)
        }}
      />
      <Loader
        show={props.showLoader}
        fullWidth={true}
        color="green"
        small={false}
      />
    </React.Fragment>
  )
}

export default PC
